import type { SVGProps } from 'react';
const SvgSatellite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#satellite_svg__a)">
      <path
        fill="currentColor"
        d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2ZM5 4.99h3C8 6.65 6.66 8 5 8V4.99ZM5 12v-2c2.76 0 5-2.25 5-5.01h2C12 8.86 8.87 12 5 12Zm0 6 3.5-4.5 2.5 3.01L14.5 12l4.5 6H5Z"
      />
    </g>
    <defs>
      <clipPath id="satellite_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSatellite;
